import { render, staticRenderFns } from "./RouterGroup.vue?vue&type=template&id=9d1c51e4"
import script from "./RouterGroup.vue?vue&type=script&lang=js"
export * from "./RouterGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports